<div class="nlp-base" [ngClass]="productViewData?.productDetails?.meta?.model?.style ? productViewData?.productDetails?.meta?.model?.style : 'primary-type-1'">
    <header>
        <div class="bg-wrapper" [ngStyle]="{'background-image': 'url('+ backagroundImage +')' }">
            <div class="nav-overlay">
                <nav class="d-flex align-items-center p-3">
                    <a class="navbar-brand mr-auto" href="javascript:void(0);" qid="groupSelection-1" (click)="navigateToDashboard()" [attr.aria-label]="'SHARED._COMMON_ACROSS_PAGES.HEADER.SCREEN_READER.CAMBRDIGE_LOGO' | translate">
                        <img class="brand-img" src="{{imagesBasePath}}assets/img/cambridge-logo.png" [attr.data-src-2x]="imagesBasePath+'assets/img/cambridge-logo-2x.png'" srcset="{{imagesBasePath}}assets/img/cambridge-logo.png 1x, {{imagesBasePath}}assets/img/cambridge-logo-2x.png 2x" alt="{{ 'SHARED._COMMON_ACROSS_PAGES.HEADER.SCREEN_READER.CAMBRDIGE_LOGO' | translate }}">
                    </a>
                    <div class="d-flex align-items-center navbar-nav">
                        <div class="userProfile dropdown">
                            <a class="nav-link d-flex align-items-center justify-content-center dropdown-toggle" qid="groupSelection-2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="javascript:void(0)">
                                <span class="nemo-profile-wrapper d-flex">
                                    <i class="nemo-font nemo-profile" aria-hidden="true"></i>
                                    <a class="user-name mx-1 align-self-center" qid="groupSelection-3"> {{userData?.firstName}}</a>
                                </span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                                <a class="dropdown-item" href="javascript:void(0)" qid="groupSelection-4" (click)="logOut()">{{'SHARED._COMMON_ACROSS_PAGES.HEADER.LOGOUT' | translate}}</a>
                            </div>
                    </div>
                    </div>
                </nav>
            </div>
            <div class="container-fluid text-center pb-3 px-0">
                <div class="row no-gutters">
                    <div class="col-12 offset-lg-2 col-lg-8">
                        <img class="img-fluid product-cover-image" [src]="isAbsoluteUrl(productViewData?.bundleDetails?.image) ? productViewData?.bundleDetails?.image : productViewData?.bundleDetails?.path + '/' + getProdCodeForCoverImage() + '/' + productViewData?.bundleDetails?.image" alt="Product Cover Image">
                        <h1> {{productViewData.bundleDetails?.title}} </h1>
                        <h2 class="mb-0"> {{productTitle}} </h2>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <main>
        <div class="container-fluid body-wrapper p-0"> 
            <!-- <div class="announcement-wrapper">
                <service-announcement></service-announcement>
            </div> -->
            <div class="group-selection-container">
                <div class="selection-header">
                    <a qid="groupSelect-back" href="javascript:void(0);" (click)="navigateToHome()" aria-label="Navigate Back"><i class="fa fa-angle-left mr-3" aria-hidden="true"></i></a>
                    <h1 class="activity-title mb-0">{{unitIndex+1}}.{{lessonIndex+1}} {{selectedActivity?.name}}</h1>
                </div>
                <div class="groups-wrapper card">
                    <div class="group-items-wrapper">
                        <div class="group-item-header">
                            <h2 class="info-title">
                                {{'TEACHER.GROUPSELECTON.SELECT_GROUP' | translate}}
                            </h2>
                            <div class="sorted-info d-flex align-items-center mb-2" *ngIf="activeGroupsData.length > 1">
                                <div>{{'TEACHER.GROUPSELECTON.GROUP_SORT_BY' | translate}}</div>
                                <div class="sort-by-date-container ml-2">            
                                    <div class="sort-order-by-date">
                                        <a class="d-flex align-items-center" qid="grp-sort-1" href="javascript:void(0);" (click)="sortByDateActiveGroupAsc = !sortByDateActiveGroupAsc">
                                            {{ sortByDateActiveGroupAsc ? ('TEACHER.GROUPSELECTON.GROUP_SORT_OLDEST_FIRST' | translate) : ('TEACHER.GROUPSELECTON.GROUP_SORT_NEWEST_FIRST' | translate)}}
                                            <span class="d-inline-flex flex-column ml-2">
                                                <i class="fa fa-caret-up" [ngClass]="{'grey-color': !sortByDateActiveGroupAsc}" aria-hidden="true"></i>
                                                <i class="fa fa-caret-down" [ngClass]="{'grey-color': sortByDateActiveGroupAsc}" aria-hidden="true"></i>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="group-item" *ngFor="let group of activeGroupsData | orderby:[sortByDateActiveGroupAsc ? 'group.startdate' : '!group.startdate'];let i = index;">
                            <a class="items-details" href="javascript:void(0);" (click)="launchItem(group.uuid)" [attr.qid]="'groupSelect-G' + i">
                                <p class="item-title">
                                    <span>{{group.title}}</span>
                                    <i aria-hidden="true" class="fa fa-angle-right ml-2"></i>
                                </p>
                                <div class="date-section">
                                    {{group?.group?.startdate | date:'MMMM dd, yyyy'}}
                                </div>
                            </a>
                        </div>
                        <div *ngIf="!activeGroupsData?.length" class="pt-4">
                            {{'TEACHER.GROUPSELECTON.NO_GROUP' | translate}}
                        </div>
                    </div>
                    <div class="archived-groups-wrapper" *ngIf="archivedGroupsData?.length">
                        <div class="group-item-header">
                            <a href="javascript:void(0);" class="info-title" id="archivedGroupHeading" data-toggle="collapse" data-target="#archivedGroups" aria-expanded="false" aria-controls="archivedGroups" qid="groupSelect-G-2">
                                {{'TEACHER.GROUPSELECTON.ARCHIVED_GROUPS' | translate}}
                            </a>
                            <div class="sorted-info mb-2" *ngIf="archivedGroupsData.length > 1">
                                <div>{{'TEACHER.GROUPSELECTON.GROUP_SORT_BY' | translate}}</div>
                                <div class="sort-by-date-container ml-2">            
                                    <div class="sort-order-by-date">
                                        <a class="d-flex align-items-center" qid="archive-grp-sort-1" href="javascript:void(0);" (click)="sortByDateArchiveGroupAsc = !sortByDateArchiveGroupAsc">
                                            {{ sortByDateArchiveGroupAsc ? ('TEACHER.GROUPSELECTON.GROUP_SORT_OLDEST_FIRST' | translate) : ('TEACHER.GROUPSELECTON.GROUP_SORT_NEWEST_FIRST' | translate)}}
                                            <span class="d-inline-flex flex-column ml-2">
                                                <i class="fa fa-caret-up" [ngClass]="{'grey-color': !sortByDateArchiveGroupAsc}" aria-hidden="true"></i>
                                                <i class="fa fa-caret-down" [ngClass]="{'grey-color': sortByDateArchiveGroupAsc}" aria-hidden="true"></i>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="group-items-wrapper collapse" aria-labelledby="archivedGroupHeading" id="archivedGroups">
                            <div class="group-item" *ngFor="let group of archivedGroupsData | orderby:[sortByDateArchiveGroupAsc ? 'group.startdate' : '!group.startdate'];let i = index;">
                                <a class="items-details" href="javascript:void(0);" (click)="launchItem(group.uuid)" [attr.qid]="'groupSelect-G-3' + i">
                                    <p class="item-title">
                                        <span>{{group.title}}</span>
                                        <i aria-hidden="true" class="fa fa-angle-right ml-2"></i>
                                    </p>
                                    <div class="date-section">
                                        {{group?.group?.startdate | date:'MMMM dd, yyyy'}} &#x2192; {{group?.last_archived_on | date:'MMMM dd, yyyy'}}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>